import { Link } from "react-router-dom";
import { Users, BedDouble } from "lucide-react";
import { imgSrc } from "@/lib/api";
import { Price } from "@/context/CurrencyContext";
import { SampleBadge } from "@/components/site/Cards";

export const naira = (v) => `₦${Math.round(Number(v) || 0).toLocaleString("en")}`;

export const ShortletCard = ({ s, idx }) => (
  <article className="group" data-testid={`shortlet-card-${idx}`}>
    <Link to={`/shortlets/${s.id}`} className="block" data-testid={`shortlet-card-link-${idx}`}>
      <figure className="relative overflow-hidden bg-gw-card m-0">
        <SampleBadge show={s.is_sample} />
        {s.images?.[0] ? (
          <img src={imgSrc(s.images[0])} alt={s.title} loading="lazy" className="w-full aspect-[4/3] object-cover transition-transform duration-700 group-hover:scale-105" />
        ) : <div className="aspect-[4/3]" />}
        <span className="lab absolute bottom-3 right-3 bg-gw-ground text-white px-2 py-1">Shortlet</span>
      </figure>
      <div className="flex items-start justify-between gap-4 mt-3">
        <p className="lux text-2xl">{s.title}</p>
        {s.nightly_rate > 0 && (
          <p className="lab mt-2 text-gw-accent shrink-0 text-right">
            <Price price={naira(s.nightly_rate)} testId={`shortlet-card-rate-${idx}`} /><span className="block opacity-70 normal-case">per night</span>
          </p>
        )}
      </div>
      <p className="text-sm text-gw-accent/80 flex flex-wrap gap-x-4 gap-y-1">
        {s.location && <span>{s.location}</span>}
        {s.bedrooms ? <span className="inline-flex items-center gap-1"><BedDouble size={13} />{s.bedrooms} bed</span> : null}
        <span className="inline-flex items-center gap-1"><Users size={13} />Up to {s.max_guests}</span>
      </p>
      <span className="lab text-gw-accent inline-flex gap-2 mt-2">Check dates <span className="transition-transform duration-200 group-hover:translate-x-1">→</span></span>
    </Link>
  </article>
);
